import { getLocationByDomain } from "@/api/location-settings";
import { useQuery, queryOptions } from "@tanstack/react-query";
import { locationSettingsKeys } from "./keys";

interface Props {
	domain: string;
}

export function getDomainLocationSettingsQueryOptions(domain: string) {
	return queryOptions({
		queryFn: () => getLocationByDomain(domain),
		queryKey: locationSettingsKeys.locationSettingsByDomain(domain),
		staleTime: Number.POSITIVE_INFINITY,
		retry: false,
		refetchOnWindowFocus: false,
	});
}

function useGetDomainLocationSettings(props: Props) {
	const { domain } = props;

	return useQuery(getDomainLocationSettingsQueryOptions(domain));
}

export default useGetDomainLocationSettings;
